import clsx from 'clsx';
import { Button } from '../../../_custom';
import type { MobileSectionTabBarProps } from '../../types';
import styles from './MobileSectionTabBar.module.scss';

const MobileSectionTabBar = ({ tabs, currentTab, onTabClick, renderStatusIcon }: MobileSectionTabBarProps) => (
    <nav className={styles.TabBar} aria-label="Company sections">
        {tabs.map((tab) => {
            const isActive = tab.id === currentTab;
            return (
                <Button
                    key={tab.id}
                    type="button"
                    text={
                        <span className={styles.TabContent}>
                            <span className={styles.Label}>{tab.label}</span>
                            {renderStatusIcon(tab.id ?? '')}
                        </span>
                    }
                    aria-current={isActive ? 'page' : undefined}
                    className={clsx(styles.Tab, { [styles.TabActive]: isActive })}
                    onClick={() => onTabClick(tab)}
                />
            );
        })}
    </nav>
);

export default MobileSectionTabBar;
